export default __webpack_public_path__ + "static/media/menuRemover.fa96dbe9.svg";